import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CoverpathControllerInterface } from '../../../interfaces/controller/CoverpathControllerInterface';
import { Utils } from '../../../../../common/js/Utils';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { WorkflowService } from '../../../services/workflow/workflow.service';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { productTypes } from '../../../../../common/js/static/Product';
import type { CasApplication } from '../../../../classes/coverpath_subclasses/CasApplication';
import type { CoverpathAnnuity } from '../../../../classes/coverpath_subclasses/CoverpathAnnuity';
import { CoverpathAnnuityStatus } from '../../../../../coverpath-client/public/js/components/account-center/policy-status/annuity-status';

@Component({
  moduleId: module.id,
  selector: 'annuity-overview-card',
  templateUrl: './annuity-overview-card.component.html',
})
export class AnnuityOverviewCardComponent implements OnInit {
  @Input() annuity: CoverpathAnnuity;
  router: Router;
  controller: CoverpathControllerInterface;
  application: CasApplication;
  caseType: string;
  initialPurchaseAmount: string;
  premium: string;
  cardStatusTitles: string[];
  cardStatusSubTitles: string[];
  isCancelled: boolean = false;
  shouldShowPremium: boolean = true;
  annuityDescription: string = '';

  constructor(
    router: Router,
    protected amorphicService: AmorphicService,
    protected workflowService: WorkflowService,
    protected navigationService: NavigationService
  ) {
    this.router = router;
  }

  ngOnInit(): void {
    this.setAllProperties();
  }

  async setAllProperties(): Promise<void> {
    const annuityStatus = new CoverpathAnnuityStatus(this.amorphicService, this.annuity);
    this.cardStatusTitles = annuityStatus.getPolicyStatusTitle();
    this.cardStatusSubTitles = await annuityStatus.getPolicyStatusSubTitle();
    this.caseType = this.getCaseType(this.annuity);
    this.initialPurchaseAmount = Utils.formatCurrency(this.annuity.initialPurchaseAmount, 0);
    this.premium = Utils.formatCurrency(this.annuity.initialPurchaseAmount, 0);
    this.annuityDescription = this.getPolicyDescription(this.annuity);
  }

  getCaseType(annuity: CoverpathAnnuity) {
    return `Application`;
  }

  getPolicyDescription(annuity: CoverpathAnnuity) {
    return productTypes.Annuity.productNames[annuity.product];
  }

  goToCase(annuity: CoverpathAnnuity) {
    this.router.navigate(['account-center-detailed-view'], {
      queryParams: { applicationNumber: annuity.application.applicationNumber },
    });
  }
}
